import { Minus, Plus, Trash } from 'feather-icons-react/build/IconComponents';
import PropTypes from 'prop-types';
import React from 'react';

const OrderList = ({ orderItems, handleRemoveItem, handleQuantityChange, isDragging, setOrderItems }) => {
    return (
        <div className="product-added block-section">
            <div className="head-text d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                    <h5 className="me-2">Order Details</h5>
                    <div className="badge bg-light text-gray-9 fs-12 fw-semibold py-2 border rounded">
                        Items: <span className="text-teal">{orderItems.length}</span>
                    </div>
                </div>
                <a

                    className="d-flex align-items-center clear-icon fs-10 fw-medium"
                    onClick={() => setOrderItems([])}
                >
                    Clear all
                </a>
            </div>
            {isDragging && (
                <div className="drop-message text-center text-success py-2 fw-bold">
                    Drop product here to add to cart
                </div>
            )}
            <div className="product-wrap">
                {orderItems.length === 0 && !isDragging ? (
                    <div className="empty-cart">
                        <div className="fs-24 mb-1">
                            <i className="ti ti-shopping-cart"></i>
                        </div>
                        <p className="fw-bold">No Products Selected</p>
                    </div>
                ) : (
                    <div className="product-list border-0 p-0">
                        <div className="table-responsive">
                            <table className="table table-borderless" style={{ borderCollapse: 'separate', borderSpacing: '0 10px' }}>
                                <thead>
                                    <tr>
                                        <th className="fw-bold bg-light">Item</th>
                                        <th className="fw-bold bg-light">QTY</th>
                                        <th className="fw-bold bg-light">Action</th>
                                        <th className="fw-bold bg-light text-end">Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderItems.map(item => {
                                        console.log("Item", item)
                                        const displayPrice = item.discountedPrice || item.price;
                                        console.log("Order Amount", displayPrice)
                                        return (
                                            <tr key={`${item.id}-${item.variantId || 'single'}`} className="product-row">
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="product-img me-1" style={{ width: '30px', height: '30px', overflow: 'hidden', borderRadius: '4px', marginRight: '8px', border: '1px solid #d1c6c6' }}>
                                                            <img 
                                                                src={Array.isArray(item.image) && item.image.length > 0 ? item.image[0] : 'https://odabill.com/assets/img/product/noimage.png'}

                                                                onError={(e) => (e.target.src = 'https://odabill.com/assets/img/product/noimage.png')}

                                                                alt={item.name}
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                        <h6 className="fs-13 fw-normal me-auto">
                                                            <a className="link-default" data-bs-toggle="modal" data-bs-target="#products">
                                                                {item.name}
                                                            </a>
                                                        </h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="qty-item m-0">
                                                        <a
                                                            className="dec d-flex justify-content-center align-items-center"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="minus"
                                                            onClick={() => handleQuantityChange(item.id, item.variantId, -1)}
                                                        >
                                                            <Minus />
                                                        </a>
                                                        <input
                                                            type="text"
                                                            className="form-control text-center"
                                                            name="qty"
                                                            value={item.quantity ?? 1}
                                                            readOnly
                                                        />
                                                        <a
                                                            className="inc d-flex justify-content-center align-items-center"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="plus"
                                                            onClick={() => handleQuantityChange(item.id, item.variantId, 1)}
                                                        >
                                                            <Plus />
                                                        </a>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <a
                                                        className="delete-icon"
                                                        onClick={() => handleRemoveItem(item.id, item.variantId)}
                                                        style={{ color: '#ff4d4f', border: '1px solid #ff4d4f', padding: '0px 3px 3px 3px', cursor: 'pointer' }}
                                                    >
                                                        <Trash size={14} />
                                                    </a>
                                                </td>
                                                <td className="fs-13 fw-semibold text-gray-9 text-end">
                                                    PKR {(displayPrice * (item.quantity ?? 1)).toFixed(2)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

OrderList.propTypes = {
    orderItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
            price: PropTypes.number.isRequired,
            discountedPrice: PropTypes.number,
            quantity: PropTypes.number,
            variantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            discount_type: PropTypes.string,
            discount_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            discountAmount: PropTypes.number,
        })
    ).isRequired,
    handleRemoveItem: PropTypes.func.isRequired,
    handleQuantityChange: PropTypes.func.isRequired,
    isDragging: PropTypes.bool,
    setOrderItems: PropTypes.func.isRequired,
};

OrderList.defaultProps = {
    isDragging: false,
};

export default OrderList;